import { useEffect, useCallback } from "react";
import { getSocket, joinPortalUserRoom } from "../services/socketService";
import { useAuth } from "../auth/AuthProvider";

const EVENT = "ADVERTISEMENT_LIST_UPDATED";

/**
 * Joins the calling user's private socket room and listens for
 * ADVERTISEMENT_LIST_UPDATED events scoped to that user only.
 *
 * @param {(ads: Array<{originalFileName: string, mediaUrl: string}>) => void} onUpdate
 */
const useAdvertisementSocket = (onUpdate) => {
  const { user } = useAuth();
  const userId = user?.id || user?._id;

  const handleUpdate = useCallback(
    (advertisements) => {
      if (typeof onUpdate === "function") onUpdate(advertisements);
    },
    [onUpdate]
  );

  useEffect(() => {
    if (!userId) return;

    joinPortalUserRoom(userId);

    const socket = getSocket();
    socket.on(EVENT, handleUpdate);

    return () => {
      socket.off(EVENT, handleUpdate);
    };
  }, [userId, handleUpdate]);
};

export default useAdvertisementSocket;
